import { TextInput, TextInputProps } from '@optimus-web/core';

export type ReadOnlyProps = Omit<TextInputProps, 'size' | 'disabled'>;

export const ReadOnly = (props: ReadOnlyProps) => <TextInput {...props} disabled />;
